import { render, staticRenderFns } from "./Menuleft.vue?vue&type=template&id=c27ec29c&"
import script from "./Menuleft.vue?vue&type=script&lang=js&"
export * from "./Menuleft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports